


































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { mixins } from "vue-class-component";
import { ErrorsMixin } from "@/employer/components/shared/ErrorsMixin";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useFamilyStore } from "@/employee/store/family";

@Component
export default class Finish extends mixins(ErrorsMixin) {
  @Prop() routeToFinish;

  portalCustomizationStore = usePortalCustomizationStore();
  familyStore = useFamilyStore();

  isLoaded = false;

  initializeFromStateValue () {
    const noOfCardHolders = this.familyStore.noOfCardHolders;
    if (!noOfCardHolders) {
      return;
    } else if (this.familyStore.isFamilyStateLoaded) {
      this.isLoaded = true;
    } else {
      this.isLoaded = false;
    }
  }

  mounted (): void {
    if (!this.familyStore.isFamilyStateLoaded) {
      this.familyStore.initialize().catch(this.handleError);
    } else {
      this.initializeFromStateValue();
      this.$emit("complete");
    }
  }

  @Watch("familyStore.isFamilyStateLoaded")
  onStateChange (payLoad) {
    this.initializeFromStateValue();
    if (payLoad) {
      this.$emit("complete");
    }
  }

  get oneCardOnly () {
    return this.familyStore.noOfCardHolders === 1;
  }

  get imageSrc () {
    if (!this.portalCustomizationStore.isCustomDebitCardImage) {
      return require("../../../assets/bend_debit_card_2x.svg");
    }
    return this.portalCustomizationStore.debitCardImageSrc;
  }
}
